import { render } from "./NavBar.vue?vue&type=template&id=9320f1b2&scoped=true&ts=true"
import script from "./NavBar.vue?vue&type=script&lang=ts"
export * from "./NavBar.vue?vue&type=script&lang=ts"

import "./NavBar.vue?vue&type=style&index=0&id=9320f1b2&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/atomic-design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9320f1b2"]])

export default __exports__